import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import type { SearchHistoryItem } from "@/stores/searchHistory";

interface Props {
    history: SearchHistoryItem[];
    onSelect: (item: SearchHistoryItem) => void;
    onClear: (id: string) => void;
}

export default function SearchRecents({ history, onSelect, onClear }: Props) {
    const { t } = useTranslation();

    return (
        <>
            <Typography
                variant="subtitle2"
                sx={{ px: 2, py: 1, bgcolor: "action.hover", fontWeight: 600 }}
            >
                {t("search.recent-searches", { ns: "browse" })}
            </Typography>
            {history.map((item) => (
                <ListItem key={item.id} disablePadding>
                    <ListItemButton
                        onClick={() => onSelect(item)}
                        sx={{ py: 0.5 }}
                    >
                        <ListItemText
                            primary={item.label}
                            secondary={item.slug.toUpperCase()}
                            slotProps={{
                                primary: {
                                    variant: "body2",
                                    fontWeight:
                                        item.type === "specialty" ? 600 : 400,
                                },
                                secondary: { variant: "caption" },
                            }}
                        />
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onClear(item.id);
                            }}
                        >
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    </ListItemButton>
                </ListItem>
            ))}
        </>
    );
}
